import * as React from 'react'
import { useComputed } from '@preact/signals-react';

import {CommonFilters} from '@components'
import {BACKEND_APIS} from "@constants"
import {isLoadingCommonFilters, customerID} from "@signals";
import {useEffect} from "react";
import {UserActivitiesIsEmpty} from "./@signals";
import {isLoadingCards, isLoadingTops, isLoadingEvo, isLoadingTable} from "./@signals";


export default function AdminUserActivitiesFilters() {
    const isFinishedLoading = useComputed(() =>
		!isLoadingCards.value &&
		!isLoadingTops.value?.length &&
		!isLoadingEvo.value &&
		!isLoadingTable.value
	)

    useEffect(() => {
        if (isFinishedLoading.value) {
            isLoadingCommonFilters.value = false;
        }
        }, [isFinishedLoading.value]);

    return <CommonFilters
        components={{
            country: true,
            customer: customerID.value === 0,
        }}
        compProps={{
			country: {urlAjax: `${BACKEND_APIS.ADMIN}/user-activities/country-options`}
		}}
        onSubmit={() =>{
            UserActivitiesIsEmpty.value = false
            isLoadingCommonFilters.value = true
        }}
        startLaunch
    />
}